/**
 * v0.8.2: an identifier character matches the lexer — a Unicode `ID_Continue`
 * (letters of any script, digits, `_`, combining marks) OR an internal hyphen
 * (`arch-module`). Centralized so completion word-replace and selection-range
 * double-click both treat Cyrillic / CJK / `2FA` / hyphenated names as one word.
 */
const IDENT_CHAR = /[\p{ID_Continue}-]/u;
// ID_Continue WITHOUT the hyphen. The lexer keys identifiers on ID_Continue and
// admits a hyphen ONLY when it joins two runs (`arch-module`) — a LEADING or
// TRAILING `-` stays outside the token. A word-boundary scan that wants to match
// the lexer exactly (so a completion replace doesn't swallow a stray `-`) must
// treat the hyphen conditionally, via this predicate.
const IDENT_CONTINUE = /\p{ID_Continue}/u;

export function isIdentChar(ch: string): boolean {
  return ch.length > 0 && IDENT_CHAR.test(ch);
}

export function isIdentCharCode(code: number): boolean {
  return Number.isFinite(code) && IDENT_CHAR.test(String.fromCodePoint(code));
}

/** ID_Continue excluding the hyphen (see {@link IDENT_CONTINUE}). */
export function isIdentContinueCode(code: number): boolean {
  return Number.isFinite(code) && IDENT_CONTINUE.test(String.fromCodePoint(code));
}
